import React from 'react';
import cookie from 'react-cookies';
import {withFirestore} from 'react-firestore';

import SharePanel from '../components/SharePanel';
import MsgNetLoading from '../components/MsgNetLoading';
import TopHeaderMenu from '../components/TopHeaderMenu';
import ResultadoDetailHeader from '../components/ResultadoDetailHeader';
import ResultadoDetailTiempo from '../components/ResultadoDetailTiempo';
import ResultadoDetailMenu from '../components/ResultadoDetailMenu';
import ResultadoDetailTablaPasos from '../components/ResultadoDetailTablaPasos';
import ResultadoDetailTablaPuestos
  from '../components/ResultadoDetailTablaPuestos';
import ResultadoDetailTablaRankings
  from '../components/ResultadoDetailTablaRankings';
import {calculaPrevision} from '../utils/time';

class ResultadoScreen extends React.Component {
  // ...
  constructor (props) {
    super(props)
    this.state = {
      time: 0,
      evento: null,
      sectores: [],
      controlList: [],
      resultado: null,
      notificar: false,
      competicion: null,
      botonSeleccionado: 1,
      showSharePanel: false,
      rankingsResultados: []
    }
    this.unlisten = {
      evento: null,
      control: null,
      sectores: null,
      resultado: null,
      competicion: null
    }
  }

  toogleSharePanel () {
    this.setState(state => ({
      showSharePanel: !this.state.showSharePanel
    }))
  }

  componentDidMount () {
    const { firestore } = this.props
    const dorsal = parseInt(this.props.match.params.dorsal, 10)
    const competicionId = parseInt(this.props.match.params.competicionId, 10)

    const favoritos = cookie.load('favoritos-' + competicionId)
    if (favoritos) {
      this.setState({ favoritos })
    } else {
      this.setState({ favoritos: [] })
    }

    this.unlisten.competicion = firestore.doc(`competicion/${competicionId}`).onSnapshot(snapshot => {
      let competicion = snapshot ? snapshot.data() : null
      if (competicion) {
        competicion.id = snapshot.id
      }
      this.setState({ competicion })
    })
    this.unlisten.resultado = firestore.doc(`resultado/${competicionId}-${dorsal}`).onSnapshot(snapshot => {
      let resultado = snapshot ? snapshot.data() : null
      if (resultado) {
        resultado.id = snapshot.id
      }
      this.setState({ resultado })
    })

    this.unlisten.sectores = firestore.collection('sector/')
      .where('competicion_id', '==', competicionId)
      .orderBy('inicio', 'asc')
      .onSnapshot((snapshot) => {
        let sectores = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        this.setState({ sectores })
      })

    this.unlisten.rankingsResultados = firestore.collection('ranking_resultado/')
      .where('dorsal', '==', dorsal)
      .where('competicion_id', '==', competicionId)
      .onSnapshot(snapshot => {
        let rankingsResultados = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        // console.info(dorsal)
        // console.info(competicionId)
        // console.info(rankingsResultados)
        this.setState({rankingsResultados})
      })

    this.unlisten.controles = firestore.collection('control/')
      .where('competicion_id', '==', competicionId)
      .where('visible', '==', true)
      .orderBy('distancia', 'asc')
      .onSnapshot((snapshot) => {
        let controlList = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        this.setState({ controlList })
        // this._calculaControlId(this.props.match.params.controlId)
      })

    // Actualizar prar redibujar crono, etc...
    this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000)
  }

  UNSAFE_componentWillUpdate (nextProps, nextState) {  // eslint-disable-line
    // Una vez cargada la competición obtenemos el evento:
    if (nextState.competicion !== this.state.competicion) {
      if (nextState.competicion && nextState.competicion.evento_id) {
        this.unlisten.evento = this.props.firestore.doc(`evento/${nextState.competicion.evento_id}`).onSnapshot(snapshot => {
          let evento = snapshot ? snapshot.data() : null
          if (evento) {
            evento.id = snapshot.id
          }
          this.setState({ evento })
        })
      }
    }
  }

  componentWillUnmount () {
    // Desconectamos todos os "listeners" de firestore para evitar problemas de memoria
    if (this.unlisten.evento) {
      this.unlisten.evento()
    }
    if (this.unlisten.competicion) {
      this.unlisten.competicion()
    }
    if (this.unlisten.controles) {
      this.unlisten.controles()
    }
    if (this.unlisten.sectores) {
      this.unlisten.sectores()
    }
    if (this.unlisten.resultado) {
      this.unlisten.resultado()
    }
    if (this.unlisten.rankingsResultados) {
      this.unlisten.rankingsResultados()
    }
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  esFavorito () {
    const competicionId = this.props.match.params.competicionId
    const dorsal = this.props.match.params.dorsal
    const favoritos = cookie.load('favoritos-' + competicionId)
    if (favoritos) {
      return favoritos.indexOf(parseInt(dorsal, 10)) >= 0
    }
    return false
  }

  onClickFavorito () {
    const { firestore } = this.props

    const competicionId = this.props.match.params.competicionId
    const dorsal = parseInt(this.props.match.params.dorsal, 10)

    let favoritos = this.state.favoritos
    let idx = favoritos.indexOf(dorsal)
    if (idx >= 0) {
      // dorsal es favorito ...
      favoritos.splice(idx, 1)
      if (window.FCM_TOKEN) {
        const fstKey = competicionId + '-' + dorsal + '-' + window.FCM_TOKEN
        firestore.collection('fcm').doc(fstKey).delete()
      }
      if (typeof window.ga === 'function') {
        window.ga('set', 'favoritoDel', favoritos.length)
      }
    } else {
      favoritos.push(dorsal)
      if (window.FCM_TOKEN) {
        const fstKey = competicionId + '-' + dorsal + '-' + window.FCM_TOKEN
        firestore.collection('fcm').doc(fstKey).set({
          competicion_id: competicionId,
          dorsal,
          token: window.FCM_TOKEN
        })
      }
      if (typeof window.ga === 'function') {
        window.ga('set', 'favoritoAdd', favoritos.length)
      }
    }
    this.setState({ favoritos })
    const expires = new Date()
    expires.setDate(Date.now() + 1000 * 60 * 60 * 24 * 30)
    cookie.save('favoritos-' + competicionId, favoritos, {
      path: '/',
      expires
    })
  }

  onClickBack () {
    this.props.history.goBack()
  }

  onClickNotificar () {
    // @todo: por defecto seleccionar nofificar al seleccionar favorito.
    this.setState({
      'notificar': !this.state.notificar
    })
  }

  onSelectBoton (index) {
    this.setState({'botonSeleccionado': index})
  }

  esNotificar () {
    return this.state.notificar
  }

  renderDetailTable (props) {
    switch (this.state.botonSeleccionado) {
      case 1:
        return <ResultadoDetailTablaPasos {...props} />
      case 2:
        return <ResultadoDetailTablaPuestos {...props} />
      case 3:
        return <ResultadoDetailTablaRankings rankingsResultados={this.state.rankingsResultados} />
      default:
        return <div />
    }
  }

  // ...
  render () {
    const {evento, competicion, controlList, sectores, resultado} = this.state

    if (resultado && competicion) {
      const prevision = calculaPrevision(competicion, controlList, sectores, resultado, null)

      return <div>
        <TopHeaderMenu
          onClickBack={this.onClickBack.bind(this)}
          onClickShare={this.toogleSharePanel.bind(this)}
          competicion={competicion} selected={1}
          evento={evento}
        />
        <ResultadoDetailHeader
          resultado={resultado}
          esFavorito={this.esFavorito()} onClickFavorito={this.onClickFavorito.bind(this)}
          esNotificar={this.esNotificar()} onClickNotificar={this.onClickNotificar.bind(this)}
        />
        <ResultadoDetailTiempo
          resultado={resultado}
          competicion={competicion}
          guntime={competicion.guntime}
          fechaInicio={competicion.fecha_inicio}
          prevision={prevision}
        />
        <ResultadoDetailMenu
          resultado={resultado}
          controlList={controlList}
          tieneRankings={competicion.ranking_numero > 0}
          onSelectBoton={this.onSelectBoton.bind(this)}
          botonSeleccionado={this.state.botonSeleccionado}
        />
        {this.renderDetailTable({
          competicion,
          resultado,
          prevision,
          sectores,
          controlList
        })}
        {this.state.showSharePanel && (
          <SharePanel
            close={this.toogleSharePanel.bind(this)}
            url={`/competicion/${competicion.id}/dorsal/${resultado.dorsal}`}
            title={`Resulatdos en vivo de ${resultado.nombre} ${resultado.apellidos} en ${evento.nombre}.`}
          />
        )}
      </div>
    } else {
      return <MsgNetLoading />
    }
  }
}

export default withFirestore(ResultadoScreen)



// WEBPACK FOOTER //
// ./src/containers/ResultadoScreen.js